import { ccwpApi } from "@/services";
// Define a service using a base URL and expected endpoints
type CreditorSummaryRequestType = {
  caseId: string;
  creditorId: string;
};
type ListDocumentsRequestType = {
  creditorId: string;
};
export const CreditorSummaryApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorSummaryData: builder.query<any, CreditorSummaryRequestType>({
      query: (postData) =>
        `Creditor/GetCreditorSummaryViewDetails?CaseId=${postData?.caseId}&CreditorId=${postData?.creditorId}`,
    }),
    getCreditorSummaryHeaderData: builder.query<
      any,
      CreditorSummaryRequestType
    >({
      query: (postData) =>
        `Creditor/GetCreditorSummaryHeaderDetails?CaseId=${postData?.caseId}&CreditorId=${postData?.creditorId}`,
    }),
    listDocuments: builder.query<any, ListDocumentsRequestType>({
      query: (postData) =>
        `Creditor/ListDocuments?creditorId=${postData?.creditorId}`,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCreditorSummaryDataQuery,
  useGetCreditorSummaryHeaderDataQuery,
  useListDocumentsQuery,
  useLazyGetCreditorSummaryDataQuery,
} = CreditorSummaryApi;
